import { render, staticRenderFns } from "./CheckboxAcademicLevel.vue?vue&type=template&id=528f0c32&scoped=true"
import script from "./CheckboxAcademicLevel.vue?vue&type=script&lang=js"
export * from "./CheckboxAcademicLevel.vue?vue&type=script&lang=js"
import style0 from "./CheckboxAcademicLevel.vue?vue&type=style&index=0&id=528f0c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f0c32",
  null
  
)

export default component.exports